export default __webpack_public_path__ + "static/media/frame-wood-no-corners.28bde499.png";